// Auto-generated by scripts/generate-registry.mjs from packages/modules/thcs_tran_huy_lieu_clicker/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const thcs_tran_huy_lieu_clicker: ModuleSchema = {
  "id": "thcs_tran_huy_lieu_clicker",
  "uniqueId": "B3D_THL01",
  "createdAt": "2026-10-27T15:00:00+07:00",
  "updatedAt": "2026-10-27T16:00:00+07:00",
  "label": "THCS Clicker",
  "description": "Round MX clicker with a raised THCS Tran Huy Lieu SVG logo and anniversary body relief",
  "category": "fidget",
  "tags": [
    "tran-huy-lieu",
    "school",
    "logo",
    "clicker",
    "mx-switch",
    "round"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Diameter",
      "min": 45,
      "max": 85,
      "default": 65,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3,
        4
      ],
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "round_base",
      "label": "Clicker Base and Hanger",
      "default": "#9CA3AF",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "round_switch",
      "label": "MX Switch Simulation",
      "default": "#9CA3AF",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "round_cap",
      "label": "Round Keycap",
      "default": "#FFFFFF",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "thcs_logo_black",
      "label": "THCS Logo Black",
      "default": "#000000",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "thcs_logo_red",
      "label": "THCS Logo Red",
      "default": "#D40000",
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "round_years",
      "label": "Raised 1976-2026",
      "default": "#FFFFFF",
      "targetGroupIds": [
        5
      ]
    },
    {
      "key": "round_50",
      "label": "Raised 50",
      "default": "#FFFFFF",
      "targetGroupIds": [
        6
      ]
    }
  ],
  "objects": [
    {
      "id": "clicker_base",
      "label": "Clicker Base and Hanger",
      "name": "Clicker Base and Hanger",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "round_base",
          "label": "Clicker Base and Hanger",
          "name": "Clicker Base and Hanger",
          "groupId": 0,
          "colorKey": "round_base",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "mx_switch",
      "label": "MX Switch",
      "name": "MX Switch",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 18,
      "parts": [
        {
          "id": "round_switch",
          "label": "MX Switch Simulation",
          "name": "MX Switch Simulation",
          "groupId": 1,
          "colorKey": "round_switch",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 18,
          "export_stl": true
        }
      ]
    },
    {
      "id": "keycap",
      "label": "Round White Keycap",
      "name": "Round White Keycap",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 32,
      "parts": [
        {
          "id": "round_cap",
          "label": "Round Keycap",
          "name": "Round Keycap",
          "groupId": 2,
          "colorKey": "round_cap",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 32,
          "export_stl": true
        }
      ]
    },
    {
      "id": "thcs_logo_black",
      "label": "THCS Logo Black",
      "name": "THCS Logo Black",
      "color": "#000000",
      "assembled_z_offset": 0,
      "exploded_z_offset": 42,
      "parts": [
        {
          "id": "thcs_logo_black",
          "label": "THCS Logo Black",
          "name": "THCS Logo Black",
          "groupId": 3,
          "colorKey": "thcs_logo_black",
          "defaultColor": "#000000",
          "assembled_z_offset": 0,
          "exploded_z_offset": 42,
          "export_stl": true
        }
      ]
    },
    {
      "id": "thcs_logo_red",
      "label": "THCS Logo Red",
      "name": "THCS Logo Red",
      "color": "#D40000",
      "assembled_z_offset": 0,
      "exploded_z_offset": 42,
      "parts": [
        {
          "id": "thcs_logo_red",
          "label": "THCS Logo Red",
          "name": "THCS Logo Red",
          "groupId": 4,
          "colorKey": "thcs_logo_red",
          "defaultColor": "#D40000",
          "assembled_z_offset": 0,
          "exploded_z_offset": 42,
          "export_stl": true
        }
      ]
    },
    {
      "id": "anniversary_years",
      "label": "Raised 1976-2026",
      "name": "Raised 1976-2026",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 8,
      "parts": [
        {
          "id": "round_years",
          "label": "Raised 1976-2026",
          "name": "Raised 1976-2026",
          "groupId": 5,
          "colorKey": "round_years",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 8,
          "export_stl": true
        }
      ]
    },
    {
      "id": "anniversary_50",
      "label": "Raised 50",
      "name": "Raised 50",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 12,
      "parts": [
        {
          "id": "round_50",
          "label": "Raised 50",
          "name": "Raised 50",
          "groupId": 6,
          "colorKey": "round_50",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 12,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full THCS Clicker"
    },
    {
      "id": "0",
      "label": "Download STL - Clicker Base"
    },
    {
      "id": "1",
      "label": "Download STL - MX Switch"
    },
    {
      "id": "2",
      "label": "Download STL - Keycap"
    },
    {
      "id": "3",
      "label": "Download STL - THCS Logo Black"
    },
    {
      "id": "4",
      "label": "Download STL - THCS Logo Red"
    }
  ]
};
